import { render, staticRenderFns } from "./newsletter-verify.vue?vue&type=template&id=642ac5ea&scoped=true"
import script from "./newsletter-verify.vue?vue&type=script&lang=js"
export * from "./newsletter-verify.vue?vue&type=script&lang=js"
import style0 from "./newsletter-verify.vue?vue&type=style&index=0&id=642ac5ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642ac5ea",
  null
  
)

export default component.exports